import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'styles/util';
import strings from 'localization/strings';
import bookingStatuses from 'enums/bookingStatuses';

import Box from '@material-ui/core/Box';
import Alert from '@material-ui/lab/Alert';
import LocalizedTimeAgo from 'common/LocalizedTimeAgo';

const useStyles = makeStyles(({ theme }) => ({
    nextAction: {
        display: 'flex'
    },
    bold: {
        fontWeight: 'bold'
    },
    buttonContainer: {
        marginTop: theme.spacing(2),
        display: 'flex',
        gap: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        }
    }
}));

const BookingNextAction = ({ booking, buttons, className, isOwner = false }) => {
    const classes = useStyles();

    const formatNextAction = () => {
        let deadline;
        switch(booking.bookingStatus) {
            case bookingStatuses.requested.key:
                deadline = booking.confirmationDeadline;
                break;
            case bookingStatuses.confirmed.key:
                deadline = booking.initialPaymentDeadline;
                break;
            default:
                break;
        }

        const text = strings.formatString(strings.nextActions[isOwner ? 'owner' : 'tenant'][booking.bookingStatus], deadline ? <LocalizedTimeAgo date={deadline} className={classes.bold} /> : '');
        const renderedButtons = buttons[booking.bookingStatus]?.render();
        return text
            ? (
                <Alert severity="info" className={classes.nextAction}>
                    <Box>
                        {text}
                    </Box>
                    {
                        renderedButtons &&
                        (
                            <Box className={classes.buttonContainer}>
                                {renderedButtons}
                            </Box>
                        )
                    }
                </Alert>
            )
            : null;
    };

    const nextAction = formatNextAction();

    return (
        nextAction && <Box className={className}>{nextAction}</Box>
    );
};

BookingNextAction.propTypes = {
    booking: PropTypes.object.isRequired,
    buttons: PropTypes.object.isRequired,
    className: PropTypes.string,
    isOwner: PropTypes.bool
};

export default BookingNextAction;
